import { Guid } from '../../../../../../store/model/guid';

export function anyAssetUpdated(prevAssetIds: Array<Guid | null> | undefined, assetIds: Array<Guid | null>): boolean {
  if (prevAssetIds === undefined) {
    return true;
  }

  if (prevAssetIds === assetIds) {
    return false;
  }

  return assetIds.reduce((changeOccurred: boolean, assetId, index) => {
    const assetIdIsSame = prevAssetIds[index] === assetId;
    if (assetIdIsSame) {
      return changeOccurred;
    }

    const noAsset = assetId === null;
    if (noAsset) {
      return changeOccurred;
    }

    return true;
  }, false);
}
